import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SubmissionFeedbackForm } from '../forms/SubmissionFeedbackForm';

type SubmissionFeedbackModalProps = {
  submissionUuid: string;
  isOpen: boolean;
  onClose: () => void;
};

export const SubmissionFeedbackModal = ({ submissionUuid, isOpen, onClose }: SubmissionFeedbackModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal title={t('submissions.feedback')} isOpen={isOpen} loading={loading} onRequestClose={() => onClose()}>
      <SubmissionFeedbackForm
        submissionUuid={submissionUuid}
        onLoad={(loading) => setLoading(loading)}
        onClose={() => onClose()}
      />
    </Modal>
  );
};
